/* global L */

L.Control.MultiOpacity = L.Control.extend({
  options: {
    position: 'bottomright',
    defaultOpacity: 70
  },
  initialize: function(layers, layersControl, options) {
    L.Util.setOptions(this, {});
    this._layers = layers;
    this._layersControl = layersControl;
  },
  setOpacity: function(level) {
    var isFirst = true,
      self = this;
    this._layers.forEach(function(l) {
      if (self._map.hasLayer(l)) {
        if (isFirst) {
          if (l.setOpacity) 
            l.setOpacity(1);
          else           
          if (l instanceof L.FeatureGroup) l.setStyle({fillOpacity: .5, opacity: 1});

        } else {
          if (l.setOpacity)
            l.setOpacity(level);
          else {
            if (l instanceof L.FeatureGroup) l.setStyle({fillOpacity: level*.5, opacity: level});
          }
        }
        isFirst = false;
      }
    });
  },
  onAdd: function(map) {
    var self = this;
    this._map = map;

    map.on('overlayadd', function() {
    /*  self._layers.forEach(function(l) {
        if (l instanceof L.FeatureGroup)
          l.bringToFront()
      });*/
      self.setOpacity(self._el.value / 100);
    });

    map.on('overlayremove', function() {
      self.setOpacity(self._el.value / 100);
    });
 
    map.on('baselayerchange', function() {
      self.setOpacity(self._el.value / 100);
    });

    var para = L.DomUtil.create('div', 'leaflet-multiopacity');
    para.innerHTML =
      '<input class="leaflet-multiopacity-slider" type="range" min="0" max="100" value="' + this.options.defaultOpacity + '" style=" "/>';

    self.setOpacity(this.options.defaultOpacity / 100);

    this._el = para.children[0];

    this._el.addEventListener('change', function(e) {
      self.setOpacity(e.target.value / 100);
    });

    this._el.addEventListener('input', function(e) {
      self.setOpacity(e.target.value / 100);
    });

    this._el.addEventListener('mousedown', function() {
      self._map.dragging.disable();
    });

    this._el.addEventListener('mouseup', function() {
      self._map.dragging.enable();
    });
    return para;
  }
});

L.control.multiOpacity = function(layers, layersControl, opts) {
  return new L.Control.MultiOpacity(layers, layersControl, opts);
};
